const useProductHasMultipleSizes = product => {
  const length = product?.variants?.length ?? 0;
  const productHasMultipleSizes = length > 1;

  return productHasMultipleSizes;
};

export default useProductHasMultipleSizes;
